
(function() {
  var result = { translations: { "fr-ca": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} jours", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, poste {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr-ca": "static-7.973"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.973",
    "ar-eg": "static-7.973",
    "bg": "static-7.973",
    "bn": "static-7.973",
    "ca-es": "static-7.973",
    "cs": "static-7.973",
    "da": "static-7.973",
    "de": "static-7.973",
    "el": "static-7.973",
    "en-gb": "static-7.973",
    "en": "static-7.973",
    "es-mx": "static-7.973",
    "es": "static-7.973",
    "fi": "static-7.973",
    "fr-ca": "static-7.973",
    "fr": "static-7.973",
    "he-il": "static-7.973",
    "hr": "static-7.973",
    "hu": "static-7.973",
    "id": "static-7.973",
    "it": "static-7.973",
    "ja": "static-7.973",
    "ko": "static-7.973",
    "lt": "static-7.973",
    "ms": "static-7.973",
    "nl": "static-7.973",
    "no": "static-7.973",
    "pl": "static-7.973",
    "pt-br": "static-7.973",
    "pt-pt": "static-7.973",
    "ro": "static-7.973",
    "ru": "static-7.973",
    "sk": "static-7.973",
    "sl": "static-7.973",
    "sv": "static-7.973",
    "th": "static-7.973",
    "tl": "static-7.973",
    "tr": "static-7.973",
    "uk": "static-7.973",
    "vi": "static-7.973",
    "x-pseudo": "static-7.973",
    "zh-cn": "static-7.973",
    "zh-hk": "static-7.973",
    "zh-tw": "static-7.973"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr-ca', {version: 'static-7.973'}); }
})();


